import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BoxProps, makeStyles, Theme } from '@material-ui/core';
import { isMatchAuth } from 'cashout/helpers/utils';
import classnames from 'classnames';

import EventNotification from 'common/services/event-notification';

import ApIconButton from 'common/components/forms/ap-icon-button';
import { useParentPostMessage } from 'common/helpers/hooks';

const useStyles = makeStyles((theme: Theme) => ({
  backContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    margin: theme.spacing(1),
    backgroundColor: '#FFFFFF',
    '&:hover': {
      backgroundColor: 'lightgray',
    },
    height: '30px',
    width: '30px',
    '& > * ': {
      color: '#000000',
    },
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(1.5),
    },
    zIndex: 1350,
    '&.auth': {
      backgroundColor: 'transparent',
      top: '8px',
      '& > * ': {
        color: theme.colors.Text_1,
      },
    },
  },
}));

type TCloseSdkActionProps = BoxProps;

const CloseSdkAction: React.FC<TCloseSdkActionProps> = (props) => {
  const classes = useStyles();
  const eventNotification = new EventNotification('*', window);
  const isAuth = isMatchAuth();

  const onCloseSDK = () => {
    const event = isAuth ? 'close-ui' : 'close';
    eventNotification.notify(event, {}, isAuth ? 'signin' : undefined);

    //Legacy close message
    !isAuth && useParentPostMessage(parent, { action: 'close', message: 'close' }, true, undefined);
  };

  return (
    <ApIconButton
      className={classnames(classes.backContainer, props.className)}
      onClick={onCloseSDK}
    >
      <FontAwesomeIcon icon={['far', 'xmark']} size={'xs'} />
    </ApIconButton>
  );
};

export default CloseSdkAction;
